<nz-list-item>
  <nz-list-item-meta [nzTitle]="titleTpl" [nzAvatar]="iconTpl" [nzDescription]="violationsTpl">
    <ng-template #iconTpl>
      <ng-container *ngIf="iconValue">
        <nz-spin [nzSpinning]="validationItem?.validationState === validationState.LOADING">
          <nz-avatar
            [ngStyle]="{
              'background-color': iconValue.color,
              color: iconValue.borderColor
            }"
            [nzIcon]="iconValue.icon"
          ></nz-avatar>
        </nz-spin>
      </ng-container>
    </ng-template>

    <ng-template #titleTpl>
      {{ validationItem?.title }}

      <i
        [nzTooltipTitle]="validationItem?.description"
        nzTooltipPlacement="top"
        nz-tooltip
        nz-icon
        nzType="info-circle"
        nzTheme="twotone"
        nzTwotoneColor="5914fa"
      ></i>
    </ng-template>

    <ng-template #violationsTpl>
      <ng-container [ngSwitch]="validationItem?.validationState">
        <ng-container *ngSwitchCase="validationState.INITIAL">
          Validation hasn't been run
        </ng-container>

        <ng-container *ngSwitchCase="validationState.LOADING">Loading...</ng-container>

        <ng-container *ngSwitchCase="validationState.FAILED">
          {{ validationItem?.error }}

          <div class="report" *ngIf="canReport">
            <button
              *ngIf="!reportedEventId; else reported"
              nz-button
              nzSize="small"
              nzType="default"
              (click)="report()"
            >
              <i nz-icon nzType="bug"></i>
              Report this to the developers
            </button>

            <ng-template #reported>
              <span class="reported">
                <i nz-icon nzType="check" nzTheme="outline"></i>
                Reported — reference {{ reportedEventId }}
              </span>
            </ng-template>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="validationState.VALID">
          Completed all validations!
        </ng-container>

        <ng-container *ngSwitchCase="validationState.WARNING">
          <nz-list [nzDataSource]="validationItem?.violations" [nzRenderItem]="renderViolationItem">
            <ng-template #renderViolationItem let-item>
              <nz-list-item [nzContent]="pathToViolationTpl">
                <nz-list-item-meta [nzDescription]="item.message"></nz-list-item-meta>
                <ng-template #pathToViolationTpl>
                  <div nz-row nzAlign="middle" class="area">
                    <span *ngFor="let path of item.pathToViolation; trackBy: trackByRef">
                      <nz-tag nzColor="purple">
                        {{ path.area }}
                        <ng-container *ngIf="path.id">
                          ({{ path.displayId || path.id }})
                        </ng-container>
                      </nz-tag>
                      <i
                        nz-icon
                        nzColor="purple"
                        nzType="right-circle"
                        nzTheme="twotone"
                        nzTwotoneColor="5914fa"
                      ></i>
                    </span>
                  </div>
                </ng-template>
              </nz-list-item>
            </ng-template>
          </nz-list>
        </ng-container>
      </ng-container>
    </ng-template>
  </nz-list-item-meta>
</nz-list-item>
